import {
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { Form, Button } from "reactstrap";
import { APILA } from "../../../../../../../config/apila";
import { APISM } from "../../../../../../../config/apism";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import LoaderAction from "../../../../../../Loader/LoaderHome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function ModalSwitchWalas(props) {
  const {
    dataUpdate,
    dataWalas,
    GetResponseData,
    onHide,
    show,
  } = props;

  const token = localStorage.getItem("token");
  const id_user = localStorage.getItem("id_admin");

  const output_id_user = id_user?.replace(
    /[|&;$%@"<>()+,]/g,
    ""
  );

  const storageBranchGroping =
    localStorage.getItem("ysb_branch_id");

  const storageLevel =
    localStorage.getItem("level");

  const [loading, setLoading] = useState(false);
  const [loadingTeachers, setLoadingTeachers] =
    useState(false);

  const [teachers, setTeachers] = useState([]);

  const [form, setForm] = useState({
    ysb_teacher_id: "",
    ysb_teacher_id2: "",
  });

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [keyword] = useState("");

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const safeString = (value) => {
    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    return String(value);
  };

  const normalizeText = (value) => {
    return safeString(value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  };

  /*
   * Mengambil ID wali kelas dari beberapa kemungkinan
   * nama field yang dikirim API.
   */
  const getCurrentTeacherId1 = useCallback(() => {
    return safeString(
      dataWalas?.ysb_teacher_id ||
        dataWalas?.teacher_id ||
        dataWalas?.id_teacher ||
        dataWalas?.walas_id ||
        dataWalas?.id_walas ||
        dataWalas?.teacher_id_1 ||
        dataWalas?.ysb_teacher_id1 ||
        dataUpdate?.ysb_teacher_id ||
        dataUpdate?.teacher_id ||
        dataUpdate?.id_teacher ||
        dataUpdate?.walas_id ||
        dataUpdate?.id_walas ||
        ""
    );
  }, [dataWalas, dataUpdate]);

  const getCurrentTeacherId2 = useCallback(() => {
    return safeString(
      dataWalas?.ysb_teacher_id2 ||
        dataWalas?.teacher_id2 ||
        dataWalas?.teacher_id_2 ||
        dataWalas?.id_teacher2 ||
        dataWalas?.id_teacher_2 ||
        dataWalas?.walas_id2 ||
        dataWalas?.walas_id_2 ||
        dataWalas?.id_walas2 ||
        dataWalas?.id_walas_2 ||
        dataUpdate?.ysb_teacher_id2 ||
        dataUpdate?.teacher_id2 ||
        dataUpdate?.teacher_id_2 ||
        dataUpdate?.id_teacher2 ||
        dataUpdate?.id_teacher_2 ||
        ""
    );
  }, [dataWalas, dataUpdate]);

  /*
   * Nama wali kelas digunakan sebagai cadangan.
   * Jadi kalau API data_walas hanya mengirim nama,
   * modal tetap bisa menemukan ID guru dari daftar guru.
   */
  const getCurrentTeacherName1 = useCallback(() => {
    return (
      dataWalas?.name_walas ||
      dataWalas?.teacher_name ||
      dataWalas?.name_teacher ||
      dataWalas?.full_name ||
      dataUpdate?.name_walas ||
      dataUpdate?.teacher_name ||
      ""
    );
  }, [dataWalas, dataUpdate]);

  const getCurrentTeacherName2 = useCallback(() => {
    return (
      dataWalas?.name_walas_2 ||
      dataWalas?.name_walas2 ||
      dataWalas?.teacher_name_2 ||
      dataWalas?.teacher_name2 ||
      dataWalas?.name_teacher_2 ||
      dataWalas?.full_name_2 ||
      dataUpdate?.name_walas_2 ||
      dataUpdate?.name_walas2 ||
      ""
    );
  }, [dataWalas, dataUpdate]);

  /*
   * Mengambil nama guru dari respons API daftar guru.
   */
  const getTeacherName = (teacher) => {
    return (
      teacher?.full_name ||
      teacher?.name_teacher ||
      teacher?.teacher_name ||
      teacher?.name ||
      ""
    );
  };

  /*
   * Mencari ID guru berdasarkan ID terlebih dahulu.
   * Jika ID tidak tersedia, cari berdasarkan nama.
   */
  const findTeacherId = (
    teacherList,
    currentId,
    currentName
  ) => {
    const normalizedId =
      safeString(currentId);

    if (normalizedId) {
      const teacherById = teacherList.find(
        (teacher) =>
          safeString(teacher?.id) ===
            normalizedId ||
          safeString(
            teacher?.ysb_teacher_id
          ) === normalizedId
      );

      if (teacherById) {
        return safeString(
          teacherById?.id ||
            teacherById?.ysb_teacher_id
        );
      }
    }

    const normalizedName =
      normalizeText(currentName);

    if (normalizedName) {
      const teacherByName = teacherList.find(
        (teacher) =>
          normalizeText(
            getTeacherName(teacher)
          ) === normalizedName
      );

      if (teacherByName) {
        return safeString(
          teacherByName?.id ||
            teacherByName?.ysb_teacher_id
        );
      }
    }

    /*
     * Jika ID ada tetapi belum berhasil ditemukan,
     * tetap gunakan ID tersebut sebagai nilai select.
     */
    return normalizedId;
  };

  const fetchTeachers = useCallback(
    async (schoolId) => {
      if (!schoolId) {
        setTeachers([]);

        setForm({
          ysb_teacher_id: "",
          ysb_teacher_id2: "",
        });

        return;
      }

      setLoadingTeachers(true);

      try {
        const response = await APISM.get(
          `/api/teachers/all?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}&ysb_school_id=${schoolId}`,
          fetchParams
        );

        const teacherList =
          response?.data?.data || [];

        /*
         * Urutkan nama guru berdasarkan abjad.
         */
        const sortedTeachers = [
          ...teacherList,
        ].sort((teacherA, teacherB) =>
          getTeacherName(
            teacherA
          ).localeCompare(
            getTeacherName(teacherB),
            "id",
            {
              sensitivity: "base",
              numeric: true,
            }
          )
        );

        setTeachers(sortedTeachers);

        const currentTeacherId1 =
          getCurrentTeacherId1();

        const currentTeacherId2 =
          getCurrentTeacherId2();

        const currentTeacherName1 =
          getCurrentTeacherName1();

        const currentTeacherName2 =
          getCurrentTeacherName2();

        const selectedTeacherId1 =
          findTeacherId(
            sortedTeachers,
            currentTeacherId1,
            currentTeacherName1
          );

        const selectedTeacherId2 =
          findTeacherId(
            sortedTeachers,
            currentTeacherId2,
            currentTeacherName2
          );

        /*
         * Otomatis memilih walas saat ini.
         * Setelah tampil, user tetap bisa memilih guru lain.
         */
        setForm({
          ysb_teacher_id:
            selectedTeacherId1 || "",

          ysb_teacher_id2:
            selectedTeacherId2 || "",
        });
      } catch (error) {
        console.error(error);

        setTeachers([]);

        swal({
          title: "Gagal",
          text:
            error?.response?.data?.message ||
            "Gagal memuat daftar guru",
          icon: "error",
        });
      } finally {
        setLoadingTeachers(false);
      }
    },
    [
      page,
      limit,
      ascending,
      keyword,
      storageBranchGroping,
      storageLevel,
      fetchParams,
      getCurrentTeacherId1,
      getCurrentTeacherId2,
      getCurrentTeacherName1,
      getCurrentTeacherName2,
    ]
  );

  /*
   * Ketika modal dibuka, ambil guru berdasarkan
   * sekolah dari kelas yang sedang dipilih.
   */
  useEffect(() => {
    if (!show) {
      setTeachers([]);

      setForm({
        ysb_teacher_id: "",
        ysb_teacher_id2: "",
      });

      return;
    }

    const schoolId =
      dataUpdate?.ysb_school_id ||
      dataWalas?.ysb_school_id;

    if (schoolId) {
      fetchTeachers(schoolId);
    }
  }, [
    show,
    dataUpdate?.ysb_school_id,
    dataWalas?.ysb_school_id,
    fetchTeachers,
  ]);

  const handleChange = (event) => {
    const { name, value } =
      event.target;

    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!form.ysb_teacher_id) {
      swal({
        title: "Peringatan",
        text: "Walas 1 harus diisi",
        icon: "warning",
      });

      return;
    }

    // setLoading(true);

    try {
      const payload = {
        ysb_semester_id:
          dataUpdate?.ysb_semester_id,

        ysb_branch_id:
          dataUpdate?.ysb_branch_id,

        ysb_school_id:
          dataUpdate?.ysb_school_id,

        ysb_grade_level_id:
          dataUpdate?.ysb_grade_level_id,

        ysb_kelas_id:
          dataUpdate?.ysb_kelas_id,

        ysb_teacher_id:
          form.ysb_teacher_id,

        ysb_teacher_id2:
          form.ysb_teacher_id2 || null,

        user_id: output_id_user,
      };

      const response = await APILA.post(
        "/api/semester-assignments/switch-walas",
        payload,
        fetchParams
      );

      if (response?.status === 200) {
        swal({
          title: "Berhasil",
          text:
            response?.data?.message ||
            "Wali Kelas berhasil diubah",
          icon: "success",
          timer: 2000,
          buttons: false,
        });

        GetResponseData?.();
        onHide();
      }
    } catch (error) {
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Terjadi kesalahan saat mengubah wali kelas",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      centered
    >
      {loading && <LoaderAction />}

      <div className="d-flex header-modal">
        <h5>Edit Wali Kelas</h5>

        <div className="ml-auto x-close">
          <FontAwesomeIcon
            icon={faXmark}
            onClick={onHide}
            style={{
              cursor: "pointer",
            }}
          />
        </div>
      </div>

      <hr />

      <Modal.Body
        style={{
          fontSize: 13,
        }}
      >
        <Form onSubmit={handleSubmit}>
          <div className="mb-4 p-3 border rounded bg-light">
            <h6 className="mb-3 pb-2 border-bottom">
              <strong>
                Informasi Kelas
              </strong>
            </h6>

            <table className="table table-borderless table-sm">
              <tbody>
                <tr>
                  <td
                    style={{
                      width: "140px",
                    }}
                  >
                    <strong>
                      Semester
                    </strong>
                  </td>

                  <td>:</td>

                  <td>
                    {dataUpdate?.name_semester}{" "}
                    Semester{" "}
                    {
                      dataUpdate?.number_semester
                    }
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>
                      Sekolah
                    </strong>
                  </td>

                  <td>:</td>

                  <td>
                    {dataUpdate?.name_school}
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Kelas</strong>
                  </td>

                  <td>:</td>

                  <td>
                    {dataUpdate?.number_kelas}{" "}
                    {dataUpdate?.name_kelas}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label fw-bold">
                Wali Kelas 1{" "}
                <span className="text-danger">
                  *
                </span>
              </label>

              <select
                className="form-select"
                name="ysb_teacher_id"
                value={
                  form.ysb_teacher_id
                }
                onChange={handleChange}
                disabled={loadingTeachers}
                required
                style={{
                  fontSize: 13,
                }}
              >
                <option value="">
                  {loadingTeachers
                    ? "Memuat guru..."
                    : "Kosong"}
                </option>

                {teachers.map((teacher) => (
                  <option
                    key={
                      teacher?.id ||
                      teacher?.ysb_teacher_id
                    }
                    value={safeString(
                      teacher?.id ||
                        teacher?.ysb_teacher_id
                    )}
                  >
                    {getTeacherName(
                      teacher
                    )}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6">
              <label className="form-label fw-bold">
                Wali Kelas 2
              </label>

              <select
                className="form-select"
                name="ysb_teacher_id2"
                value={
                  form.ysb_teacher_id2
                }
                onChange={handleChange}
                disabled={loadingTeachers}
                style={{
                  fontSize: 13,
                }}
              >
                <option value="">
                  {loadingTeachers
                    ? "Memuat guru..."
                    : "Kosong"}
                </option>

                {teachers.map((teacher) => (
                  <option
                    key={
                      teacher?.id ||
                      teacher?.ysb_teacher_id
                    }
                    value={safeString(
                      teacher?.id ||
                        teacher?.ysb_teacher_id
                    )}
                  >
                    {getTeacherName(
                      teacher
                    )}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-4 gap-2">
            <Button
              variant="secondary"
              type="button"
              onClick={onHide}
              disabled={loading}
              style={{
                fontSize: 13,
              }}
            >
              Batal
            </Button>

            <Button
              className="btn-modal-create"
              type="submit"
              disabled={
                loading ||
                loadingTeachers ||
                !form.ysb_teacher_id
              }
            >
              {loading
                ? "Menyimpan..."
                : "Simpan Perubahan"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}